

window.onload = function() {

        /// remove attr 


        let __btn = document.getElementById('__btn');
        // __btn.addEventListener('click', function() {
        //         // __btn.insertAdjacentHTML('beforeend', '<span class="spinner-border spinner-border-sm" role="status" show="true" aria-hidden="false"></span>');
        //         __btn.setAttribute('disabled', 'disabled');
        //     })
        //Variables
        let __key = document.querySelector('.__key_name');
        let __name_a = document.querySelector('.__name_a');
        let __title = document.querySelector('.__title');
        if (__key) {
            __key.setAttribute('id', '__key_name');
        }
        if (__name_a) {
            __name_a.setAttribute('id', '__name_a');
        }
        var modal = document.querySelector('.modal-vv');
        const modalBtn = document.querySelectorAll('.modal-btn');
        var modalCloseBtn = document.querySelector('.modal__close');
        var body = document.querySelector('body');
        var modalOverlay = document.createElement('div');
        modalOverlay.className = 'modal-overlay';

        function closeModal(e) {
            modalOverlay.classList.remove('is-open');
            modal.classList.remove('is-open');
            // body.style.overflowY = "hidden";
            // __btn.removeAttribute('disabled');
            document.body.removeChild(modalOverlay);
        }
        if (modalCloseBtn) {
            modalCloseBtn.addEventListener('click', closeModal);
        }
        modalOverlay.addEventListener('click', closeModal);


        for (let index = 0; index < modalBtn.length; index++) {
            modalBtn[index].addEventListener('click', function() {
                __key.value = modalBtn[index].getAttribute('key');
                __name_a.value = modalBtn[index].getAttribute('title');
                __title.innerHTML = modalBtn[index].getAttribute('title');
                modalOverlay.classList.add('is-open');
                modal.classList.add('is-open');
                document.body.appendChild(modalOverlay);
            });

        }
    }
    // send form 
let form = document.getElementById('__st_form');
let __v__price = document.querySelector('.__v__price');
if (form) {

    form.addEventListener('submit', function(e) {
            e.preventDefault();
            if (!validatess(form)) {
                return false;
            }
            let pas = new FormData();
            pas.append('name', form.__name.value);
            pas.append('surname', form.__surname.value);
            pas.append('email', form.__email.value);
            pas.append('cmail', form.__cmail.value);
            pas.append('country', form.__country.value);
            pas.append('phone', form.__phone.value);
            pas.append('validate', form.__check.value);
            pas.append('menssaje', form.__coments.value);
            pas.append('hascontact', 1);
            fetch('/wp-content/themes/vvhotel/mail/sendmail.php', { method: 'POST', body: pas })
                .then(response => response.json())
                .then(data => {
                    // console.log(data);
                    if (data.success) {
                         alert('Thank you for contacting us shortly we will contact you');
                        form.reset();
                    }
                    if(!data.success) {
                        alert('error sending')
                    }
                })
        })
        // paypal init  pay now
    var paypalActions;
    var dataprice;
    form.__check.addEventListener('change', function() {
        if (form.__check.checked) {
            if (validatess(form)) {
                return paypalActions.enable();
            }

        }
        return paypalActions.disable();
    })

    /// get fetch price paypal 
    fetch('/wp-content/themes/vvhotel/mail/Proccess.php', { method: 'GET' })
        .then(response => response.json())
        .then(data => {
            dataprice = data;
        })
    paypal.Button.render({
            // Configure  paypal actions
            commit: true,
            validate: function(actions) {
                if (!validatess(form)) {
                    paypalActions = actions;
                    actions = actions.disable();
                }
            },
            // type send paypal
            env: 'sandbox',
            client: {
                sandbox: form.__client.value,
                // production: 'demo_pro'duction_client_id'
            },
            // Customize button (optional)
            locale: 'en_US',
            style: {
                color: 'blue',
                shape: 'pill',
                label: 'pay',
                height: 40,
                size: 'responsive'
            },
            // Enable Pay Now checkout flow (optional)
            onClick: function() {
                if (!validatess(form)) {
                    paypalActions.disable();
                }
                if (validatess(form)) {
                    paypalActions.enable();
                }
            },
            // Set up a payment currency
            payment: function(data, actions) {
                return actions.payment.create({
                    transactions: [{
                        amount: {
                            total: dataprice.Price,
                            currency: 'USD'
                        }
                    }]
                });
            },
            // Execute the payment
            onAuthorize: function(data, actions) {
                return actions.payment.execute().then(function(e) {
                    // Show responsi paypal confirmation  success
                    if (!validatess(form)) {
                        return false;
                    }
                    let pas = new FormData();
                    pas.append('name', form.__name.value);
                    pas.append('surname', form.__surname.value);
                    pas.append('email', form.__email.value);
                    pas.append('cmail', form.__cmail.value);
                    pas.append('country', form.__country.value);
                    pas.append('phone', form.__phone.value);
                    pas.append('validate', form.__check.value);
                    pas.append('menssaje', form.__coments.value);
                    pas.append('pay', form.__price.value);
                    fetch('/wp-content/themes/vvhotel/mail/sendmail.php', { method: 'POST', body: pas })
                        .then(response => response.json())
                        .then(data => {
                            console.log(data);
                            if (data.success === true) {
                                Swal.fire({
                                    icon: 'success',
                                    showConfirmButton: false,
                                    title: 'Thank you, your reservation was made successfully',
                                    footer: '<a href="https://www.veronicaviewhotel.com/">Go back to start</a>'
                                })
                                form.reset();

                            }
                        })

                });
            },
            // cancel buttom paypal
            onCancel: function(data) {
                // validatess(form);
                // window.alert('Proccesso de Pago Cancelado');
            }
        },
        '#paypal-button');
}


///*/

// validate email virify
function validateEmail(e) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (re.test(String(e.value).toLowerCase())) {
        return true;
    }

}
var cmail = document.querySelector('.email-virify');

function emailvirify(hasmail, virifymeail) {
    if (hasmail.value === virifymeail.value) {
        cmail.classList.add('d-none');
        return true
    }
    return false;
}
if (cmail) {
    cmail.previousSibling.previousSibling.addEventListener('change', function() {
        if (form.__email.value === form.__cmail.value) {
            cmail.classList.add('d-none');
        } else {
            cmail.classList.remove('d-none');
        }
    })
}
//  validate FormData
function validatess(e) {
    if (!e.__name.value) {
        return e.__name.focus();
    }
    if (!e.__surname.value) {
        return e.__surname.focus();
    }
    if (!validateEmail(e.__email)) {
        return e.__email.focus();
    }
    if (!e.__cmail.value) {
        return e.__cmail.focus();
    }
    if (!emailvirify(e.__email, e.__cmail)) {
        e.__cmail.focus();
        return cmail.classList.remove('d-none');
    }
    if (!e.__country.value) {
        return e.__country.focus();
    }
    if (!e.__phone.value) {
        return e.__phone.focus();
    }
    if (!e.__check.checked) {
        return e.__check.focus();
    }
    return true;
}
/// get height div
var tabs = document.querySelector('.wp-block-kadence-tabs .kt-tabs-title-list');
// var aside = document.querySelector('.st-aside');
var height_header = document.querySelector('.menu-container');
if (tabs) {
    tabs.style.cssText = `position:sticky;top:0px;z-index: 999`;

    // aside.style.cssText = `position:sticky;top:${height_header.offsetHeight +5}px;z-index: 999`;

}
//     (function() {
//         window.onresize = displayWindowSize;
//         window.onload = displayWindowSize;

//         function displayWindowSize() {
//             let myWidth = window.innerWidth;
//             let myHeight = window.innerHeight;

//             // your size calculation code here
//             //   document.getElementById("screen").innerHTML = myWidth + "x" + myHeight;
//             if (myWidth > 950) {;
//                 tabs.style.cssText = `position:sticky;top:${height_header.offsetHeight}px;z-index: 999`;
//                 // console.log(height_header.offsetHeight);
//             }
//             if (myWidth < 950) {
//                 // console.log(height_header.offsetHeight);
//                 tabs.style.cssText = `position:sticky;top:${height_header.offsetHeight}px;z-index: 999`;
//                 var child = tabs.childNodes;
//                 for (i = 0; i < child.length; i++) {
//                     child[i].childNodes;
//                 }
//                 // console.log(child)
//                 // tabs.removeAttribute('style');
//             }

//         };


//     })();
// }



const listass = document.querySelectorAll('.kt-title-item a');
for (let index = 0; index < listass.length; index++) {
    const element = listass[index].addEventListener('click', function() {
        console.log(listass[index].getAttribute('href'));
        window.location.href = listass[index].getAttribute('href');
    });

}
/// width menu dynamic

const widthde = document.querySelectorAll('.menus>ul>li>ul>li>ul>li');

const width = document.querySelectorAll('.menus>ul>li>ul>li');
const attr = [];
add(width);
async function add(width) {
    for (let index = 0; index < width.length; index++) {
        const element = width[index].classList.add('w-width');
        // width[index].parentNode.classList.add('new')
        // attr.push(await width[index].classList.add('w-width'));

    }

}
// async() => {
//     let result = await document.querySelectorAll('.normal-sub li');
//     console.log(result);
// }


// window.addEventListener('load', function() {
//         let result = document.querySelectorAll('.normal-sub li');
//         for (let index = 0; index < result.length; index++) {
//             const element = result[index].classList.remove('w-width');

//         }
//         let wd = document.querySelectorAll('.w-width')
//         if (wd.length == 3) {
//             for (let index = 0; index < wd.length; index++) {
//                 const element = wd[index].style.width = "33.33%";

//             }
//         }
//     })
// console.log(attrremove);

//  add icons footer 

const addIcons = document.querySelectorAll('.lista-page li a');
for (let index = 0; index < addIcons.length; index++) {
    const element = addIcons[index].insertAdjacentHTML('beforebegin', '<span class="fal fa-check-circle icon_add"><span>')
    addIcons[index].setAttribute('target', "_blank");
}
//array destructing
let g = 20,
    b = 1;
[b, g] = [g, b]
// console.log(g);
let video = document.querySelector('.vv-home-slide-text-video');